import AdminDashboard from "../AdminDashboard/AdminDashboard";
import React, { useEffect, useState } from "react";
import "../Admin.css";
import { DeleteIcon, EditIcon } from "../AdminIcon";
import { Modal, Table } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteGuidelinesFieldsData,
  deleteNewDropDownList,
  getGuidelinesFieldsData,
  getOtherDropDowndata,
  getSubCategoriesDropdown,
  getSubCategoryListData,
  otherDropDownListDataACtiveInactive,
} from "../../../services/api/admin";
import "../AdminGuidelines/AdminGuildlines.css";
import { HiPlus } from "react-icons/hi";
import ReactPaginate from "react-paginate";
import { HomeIcon } from "../../../components/Application/ApplicationIcon";
import { Message } from "../../../components/message";
import { GetLocalStorage, RemoveSession } from "../../../Utils/Utils";
import { formatDateWithSlash } from "../../../Utils/common";
import { FaPencilAlt } from "react-icons/fa";
import NotFoundTable from "../../../components/notFound/NotFoundTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { checkPermission, permissionsConfig } from "../AdminPermission/PermissionChecker";
import TotalRecords from "../../../components/notFound/TotalRecords";

const DropDownList = () => {
    const navigate = useNavigate();
    const [dropDownList, setDropDownList] = useState()
    const [tableDataLoaded, setTableDataLoaded] = useState(false)
    const [deleteData, setDeleteData] = useState('')
    const token = GetLocalStorage("userInfo")
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0); // Total number of pages
    const [orderBy, setOrderBy] = useState("desc");
    const [sortBy, setSortBy] = useState('created_at')
    const [searchData, setSearchData] = useState('')
    const [apiMessage, setApiMessage] = useState({ type: '', message: '' });
    const { state } = useLocation();
    const [searchTerm, setSearchTerm] = useState();
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
        if (!token) {
            navigate("/")
        } else {
            getDropDowndata("created_at", "1", "desc", "")
        }
    }, [])

    useEffect(() => {
        if (state && state.message) {
            setApiMessage({ type: 'success', message: state.message });
            window.scrollTo(0, 0);
            window.history.replaceState({}, document.title);
        }
    }, [state])

    const handlePageChange = (selectedPage) => {
        getDropDowndata(sortBy, selectedPage.selected + 1, orderBy, searchData); // Increment by 1 if the API starts page numbers from 1
    };

    const grantPermissionForAddFormFields = checkPermission(
        permissionsConfig.addFormDropdowns.role,
        permissionsConfig.addFormDropdowns.action,
        permissionsConfig.addFormDropdowns.type
    );
    const grantPermissionForEditFormFields = checkPermission(
        permissionsConfig.editFormDropdowns.role,
        permissionsConfig.editFormDropdowns.action,
        permissionsConfig.editFormDropdowns.type
    );
    const grantPermissionForDeleteFormFields = checkPermission(
        permissionsConfig.deleteFormDropdowns.role,
        permissionsConfig.deleteFormDropdowns.action,
        permissionsConfig.deleteFormDropdowns.type
    );

    const getDropDowndata = async (sortBy, pageNo, orderBy, searchBy) => {
        try {

            setSearchData(searchBy)
            setOrderBy(orderBy)
            setSortBy(sortBy)
            const dropdownList = await getOtherDropDowndata(sortBy, orderBy, searchBy, pageNo)
            setTotalPages(Math.ceil(dropdownList?.data?.total / dropdownList?.data?.per_page));
            setCurrentPage(pageNo > 0 ? pageNo - 1 : pageNo)
            const data = dropdownList?.data?.data
            if (dropdownList?.status === 200) {
                setDropDownList(data)
                setTotalPages(Math.ceil(dropdownList?.data?.total / dropdownList?.data?.per_page)); // Calculate total pages
                setTotalRecords(dropdownList?.data?.total ? dropdownList?.data?.total : 0);
            } else {
                setTotalRecords(0);
                setDropDownList([])
                setApiMessage({ type: 'error', message: dropdownList?.message });
            }
            setTableDataLoaded(true)
        } catch (error) {
            setTableDataLoaded(true)
            setTotalRecords(0);
            //console.log("error on dropdownList list: ", error)
            setApiMessage({ type: 'error', message: error?.message });
        }
    };

    const deleteFormField = async (item) => {
        try {
            const payload = {
                dropdown_id: item.id,
            }
            const res = await deleteNewDropDownList(payload)
            if (res?.status == 200) {
                setDeleteData('')
                getDropDowndata(sortBy, currentPage, orderBy, searchData);
            }
        } catch (e) {

        }
    }

    const handleEnableDisable = async (e, item) => {
      try {
        const formData = new FormData();
        formData.append("dropdown_id", item?.id);
        formData.append("status", e?.value);
        const data = await otherDropDownListDataACtiveInactive(formData);
        if (data.status == 200) {
          getDropDowndata(sortBy, currentPage + 1, orderBy, searchData);
        } else {
          setApiMessage({ type: "error", message: data?.message });
        }
      } catch (err) {
        setApiMessage({ type: "err", message: err.message });
      }
    };
  
  useEffect(() => {
    if (state && state.message) {
      setApiMessage({ type: "success", message: state.message });
      window.scrollTo(0, 0);
      window.history.replaceState({}, document.title);
    }
  }, [state]);

    return (
        <AdminDashboard>
            <div className='aod-outer'>
                {apiMessage && (<Message apiMessage={apiMessage} setApiMessage={setApiMessage}></Message>)}
                <div className='ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb'>
                    <div>
                        <HomeIcon /><b onClick={() => navigate("/admin/")}>Home  /</b><span> Dropdowns</span>
                    </div>
                    {(grantPermissionForAddFormFields) ? (
                        <button className='adm-tab-btn' onClick={() => navigate("/admin/form/dropdowns/add")} ><span><HiPlus />
                        </span> Add</button>
                    ) : ''}
                </div>
                <div className="aod-inner pt-0">
                    <div className="aod-bottom">
                        <div className="adm-tabs-outer">
                            <h4 className='mb-0 w-100'> Dropdowns</h4>
                            {/* <input className='w-25 px-2 form-control' placeholder='search' type="text" onChange={(e) => getDropDowndata(sortBy, 1, orderBy, e.target.value)} /> */}
                            <div className="position-relative  w-md-50 w-25">
                                <input
                                    className="px-2 form-control"
                                    placeholder="Search"
                                    type="text"
                                    value={searchTerm} // Add a state for the input value
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value); // Update the state
                                        getDropDowndata(sortBy, 1, orderBy, e.target.value)
                                    }}
                                />
                                {searchTerm && ( // Show the clear button only when there's text
                                    <button
                                        className="btn btn-clear position-absolute"
                                        onClick={(e) => {
                                            setSearchTerm(""); // Clear the input value
                                            getDropDowndata(sortBy, 1, orderBy, e.target.value) // Fetch data with empty search term
                                        }}
                                        style={{
                                            top: "50%",
                                            right: "10px",
                                            transform: "translateY(-50%)",
                                            border: "none",
                                            background: "transparent",
                                            fontSize: "1rem",
                                            cursor: "pointer",
                                        }}
                                    >
                                        &times; {/* This is the "X" icon */}
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="aod-head"></div>
                        {totalRecords > 0 ? <div className="row py-4 pb-0">
                            <div className="col-md-10"></div>
                            <TotalRecords totalRecords={totalRecords}></TotalRecords>
                        </div> : <></>}
                        <div className="ad-reg-table">
                            <Table size="sm" className='ad-cat-table mt-4'>
                                <thead>
                                    <tr>
                                        <th className='ad-sno'>S. No</th>
                                        <th className='ad-long cursor-pointer' onClick={(e) => getDropDowndata('name_en', currentPage + 1, orderBy === 'asc' ? 'desc' : 'asc', searchData)}>English Name <span><i className="fa-solid fa-sort" ></i></span></th>
                                        <th className='ad-long cursor-pointer' onClick={(e) => getDropDowndata('name_hi', currentPage + 1, orderBy === 'asc' ? 'desc' : 'asc', searchData)}>Hindi Name <span><i className="fa-solid fa-sort" ></i></span></th>
                                        <th className='ad-long cursor-pointer' onClick={(e) => getDropDowndata('created_at', currentPage + 1, orderBy === 'asc' ? 'desc' : 'asc', searchData)}>Created At <span><i className="fa-solid fa-sort" ></i></span></th>
                                        {(grantPermissionForEditFormFields) ? (<>
                                            <th className='ad-long'>Status</th></>
                                        ) : ''}
                                        {grantPermissionForEditFormFields || grantPermissionForDeleteFormFields ? (<>
                                            <th className='ad-long'>Actions</th></>
                                        ) : ''}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        dropDownList?.length > 0 ? dropDownList?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{(currentPage * 10) + (index + 1)}</td>
                                                <td>{item?.name_en ? item?.name_en : '--'}</td>
                                                <td>{item?.name_hi ? item?.name_hi : '--'}</td>
                                                <td>{item?.created_at ? formatDateWithSlash(item?.created_at) : '--'}</td>
                                                {(grantPermissionForEditFormFields) ? 
                                                    <td>
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.status == 1}
                                                                onChange={(e) => handleEnableDisable(e.target.checked ? { value: "1" } : { value: "0" }, item)}
                                                            />
                                                            <span className="slider"></span>
                                                        </label>
                                                    </td> : <></>}
                                                    {/* <td>
                                                    <div className='icon-col'><span className='ad-cat-edit' onClick={() => {
                                                        navigate("/admin/form/dropdowns/update", { state: item })
                                                    }}>        <EditIcon /></span>
                                                        <span className='ad-cat-delete ' onClick={() => setDeleteData(item)}><DeleteIcon className="pb-1" /></span>
                                                    </div></td> */}

                                                    <td>
                                                        <div className='icon-col'>
                                                        {(grantPermissionForEditFormFields) ?
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={<Tooltip id={`edit-tooltip-${item.id}`}>Edit</Tooltip>}
                                                                >
                                                                    <span
                                                                        className="ad-cat-edit"
                                                                        onClick={() => { navigate("/admin/form/dropdowns/update", { state: item }) }}
                                                                    >
                                                                        <EditIcon />
                                                                    </span>
                                                                </OverlayTrigger> : <></>}
                                                            {(grantPermissionForDeleteFormFields) ?
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={<Tooltip id={`delete-tooltip-${item.id}`}>Delete</Tooltip>}
                                                                >
                                                                    <span
                                                                        className="ad-cat-delete"
                                                                        onClick={() => setDeleteData(item)}
                                                                    >
                                                                        <DeleteIcon />
                                                                    </span>
                                                                </OverlayTrigger> : <></>}
                                                        </div>
                                                    </td>
                                            </tr>

                                        )) : tableDataLoaded ? <NotFoundTable colSpan="6"></NotFoundTable> : <></>
                                    }
                                </tbody>
                            </Table>
                            {totalPages > 1 && dropDownList?.length > 0 &&
                                <div className="d-flex w-100 justify-content-end">
                                    <ReactPaginate
                                        previousLabel={"Previous"}
                                        nextLabel={"Next"}
                                        breakLabel={"..."}
                                        pageCount={totalPages} // Total number of pages from API
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={1}
                                        onPageChange={handlePageChange} // Method to handle page click
                                        forcePage={currentPage}
                                        containerClassName={"pagination justify-content-center"} // Custom CSS classes
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={`page-item${!dropDownList?.length > 0 ? ' disabled' : ''}`}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
         
      <Modal show={deleteData?.id} onHide={() => setDeleteData("")}>
        <Modal.Header closeButton>
          <Modal.Title>
            Do you really want to delete this Dropdown ?
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <div className="suf-btn p-2">
            <button onClick={() => deleteFormField(deleteData)}>Yes</button>
            <button
              className="suf-can-butt no-btn"
              onClick={() => setDeleteData(false)}
            >
              No
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </AdminDashboard>
  );
};

export default DropDownList;
